import CustomList from "components/list/custom";
import React, { useState } from "react";
import { HoursCell } from "@/components/hours/cell";
import PercentageCell from "@/components/percentage/cell";
import { getUserById } from "@/modules/organization/employees/crud/form/read";
import { useQuery } from "@tanstack/react-query";
import { CURRENT_MONTH_END_DATE, CURRENT_MONTH_START_DATE } from "@/lib/utils";
import TimesheetEmployeeFilters from "@/modules/reports/timesheet/employees/filters";

export default function TeamBillability({ employeeId }) {
  const [departmentId, setDepartmentId] = useState(null);

  const { data: employeeData, isLoading } = useQuery({
    queryKey: ["employeeDepartment", "byuser", employeeId],
    queryFn: () => getUserById(employeeId),
    enabled: !!employeeId,
    onSuccess: (data) => {
      setDepartmentId(data?.department);
    },
    onError: (error) => {
      console.error("Error fetching employee department:", error);
    },
  });

  if (isLoading) {
    return null;
  }

  const filters = {
    type: "employee",
    department: employeeData?.department,
    startDate: CURRENT_MONTH_START_DATE,
    endDate: CURRENT_MONTH_END_DATE,
  };

  const columns = [
    {
      id: "name",
      accessorKey: "employeeFirstName",
      header: "Name",
      cell: ({ row }) => {
        const firstName = row.original.employeeFirstName;
        const lastName = row.original.employeeLastName;
        return (
          <div className="font-medium">
            {firstName} {lastName}
          </div>
        );
      },
    },
    {
      id: "department",
      accessorKey: "department",
      header: "Department",
      cell: ({ getValue }) => <span className="capitalize">{getValue()?.name}</span>,
    },
    {
      id: "availableHours",
      accessorKey: "availableHours",
      header: "Available Hours",
      cell: HoursCell,
    },
    {
      id: "totalLoggedHours",
      accessorKey: "totalLoggedHours",
      header: "Logged Hours",
      cell: HoursCell,
    },
    {
      id: "totalDraftHours",
      accessorKey: "totalDraftHours",
      header: "Draft Hours",
      cell: HoursCell,
    },
    {
      id: "totalApprovedHours",
      accessorKey: "totalApprovedHours",
      header: "Approved Hours",
      cell: HoursCell,
    },
    {
      id: "totalUnapprovedHours",
      accessorKey: "totalUnapprovedHours",
      header: "Unapproved Hours",
      cell: HoursCell,
    },
    {
      id: "totalNotReviewedHours",
      accessorKey: "totalNotReviewedHours",
      header: "Unreviewed Hours",
      cell: HoursCell,
    },
    {
      id: "utilizationPercentage",
      accessorKey: "utilizationPercentage",
      header: "Utilization",
      cell: PercentageCell,
    },
  ];

  return (
    <div key={employeeId}>
      <CustomList
        endPoint="custom-ui/dashboard"
        storageKey={`overview-team-billability-${employeeId}`}
        filters={filters}
        perPage={10}
        columns={columns}
        title="Employee Billability"
        showSearch={false}
        renderFilters={(props) =>
          TimesheetEmployeeFilters({ ...props, showDepartment: false })
        }
        inlineFilters={true}
      />
    </div>
  );
}
